export const UPDATE_SUPPLIER_BACK_BUTTON = 'UPDATE_SUPPLIER_BACK_BUTTON'
export const PENDING_SUPPLIER_ACTION = 'PENDING_SUPPLIER_ACTION'
export const COMPLETED_SUPPLIER_ACTION = 'COMPLETED_SUPPLIER_ACTION'
export const RESET_SUPPLIER_ACTION = 'RESET_SUPPLIER_ACTION'
export const SET_SUPPLIER_DATA = 'SET_SUPPLIER_DATA'
export const SET_SUPPLIER_MULTIPLE_DATA = 'SET_SUPPLIER_MULTIPLE_DATA'
export const SET_SUPPLIER_FILTER_DATA = 'SET_SUPPLIER_FILTER_DATA'
export const RESET_SUPPLIER_DATA = 'RESET_SUPPLIER_DATA'
export const SET_SUPPLIER_SHIPMENT_DATA = 'SET_SUPPLIER_SHIPMENT_DATA'
export const SET_SHIPMENT_INFO_FILTER = 'SET_SHIPMENT_INFO_FILTER'
export const UPDATE_SUPPLIERS_REGISTRY = 'UPDATE_SUPPLIERS_REGISTRY'
export const PENDING_SAVE_SUPPLIERS_ACTION = 'PENDING_SAVE_SUPPLIERS_ACTION'
export const COMPLETED_SAVE_SUPPLIERS_ACTION = 'COMPLETED_SAVE_SUPPLIERS_ACTION'
export const RESET_SAVE_SUPPLIERS_ACTION = 'RESET_SAVE_SUPPLIERS_ACTION'
export const UPDATE_SEARCH_RESULTS_SUPPLIER_DATA =
  'UPDATE_SEARCH_RESULTS_SUPPLIER_DATA'
export const SET_COMPANY_LEGAL_NAME = 'SET_COMPANY_LEGAL_NAME'
export const RESET_SUPPLIER_DATABASE = 'RESET_SUPPLIER_DATABASE'
